export const CHECK_INSURANCE_FIELDS = [
    {
        field: 'hoTen',
        title: 'Họ tên',
    },
    {
        field: 'gioiTinh',
        title: 'Giới tính',
    },
    {
        field: 'ngaySinh',
        title: 'Ngày sinh',
    },
    {
        field: 'diaChi',
        title: 'Địa chỉ',
    },
    {
        field: 'maDKBD',
        title: 'Mã ĐKBĐ',
    },
    {
        field: 'coQuanBHXH',
        title: 'Cơ quan BHXH',
    },
    {
        field: 'giaTriTheTu',
        title: 'Giá trị thẻ từ',
    },
    {
        field: 'giaTriTheDen',
        title: 'Giá trị thẻ đến',
    },
    {
        field: 'maKhuVuc',
        title: 'Mã khu vực',
    },
    {
        field: 'ngayDu5Nam',
        title: 'Ngày đủ 5 năm',
    },
];

export const initialVerifyResult = CHECK_INSURANCE_FIELDS.map(
    (item: { field: string; title: string }) => ({
        fieldName: item.title,
    })
);

export const MA_KET_QUA = {
    HOP_LE: "000",
};